export const SPINNER_SIZE_PX = {
  small: 12,
  medium: 16,
  large: 20,
  xlarge: 32,
} as const satisfies Record<string, number>;

const MUI_VIEWBOX_SIZE = 44;
const RING_WIDTH_RATIO = 1 / 6;
const ARC_FRACTION = 0.25;

export const SPINNER_THICKNESS = MUI_VIEWBOX_SIZE * RING_WIDTH_RATIO;

const RING_RADIUS = (MUI_VIEWBOX_SIZE - SPINNER_THICKNESS) / 2;

export const SPINNER_ARC_LENGTH = 2 * Math.PI * RING_RADIUS * ARC_FRACTION;
export const SPINNER_DASH_GAP = 200;
export const SPINNER_ROTATION_DURATION = '1s';
